import { useEffect } from 'react';
import LazyLoading from '../../../components/LazyLoading';
import { HTTP_STATUS_CODES } from '../../../helpers/constants';
import { isPrerender } from '../../../utils/request';
import NotFound from '../../NotFoundPage';

type RedirectToMainPageProps = {
  link: string;
};

export const RedirectToMainPage = (props: RedirectToMainPageProps) => {
  const { link } = props;
  const isPrerenderCrawler = isPrerender(window);

  useEffect(() => {
    if (!isPrerenderCrawler) {
      window.location.href = link;
    }
  }, [isPrerenderCrawler, link]);

  if (isPrerenderCrawler) {
    return (
      <NotFound
        location={link}
        statusCode={HTTP_STATUS_CODES.MOVED_PERMANENTLY}
      />
    );
  }

  return <LazyLoading />;
};
